import { createReducer } from "@reduxjs/toolkit"


export const loginReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  userDataReset: (state) => {
    state.loading = false;
    state.isAuthenticated = false;
    state.isAdmin = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  userDataRequest: (state) => {
    state.loading = true;
    state.isAuthenticated = false;
    state.isAdmin = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  userDataSuccess: (state, action) => {
    state.loading = false;
    state.isAuthenticated = true;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  userDataFailure: (state, action) => {
    state.loading = false;
    state.isAuthenticated = false;
    state.isAdmin = false;
    state.msg = action.payload;
    state.error = null;
  },
});


export const profileUpdateReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  profileUpdateReset: (state) => {
    state.loading = false;
    state.isUpdated = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  profileUpdateRequest: (state) => {
    state.loading = true;
    state.isUpdated = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  profileUpdateSuccess: (state, action) => {
    state.loading = false;
    state.isUpdated = true;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  profileUpdateFailure: (state, action) => {
    state.loading = false;
    state.isUpdated = false;
    state.data = [];
    state.msg = action.payload;
    state.error = null;
  },
});


export const googleLoginReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  googleLoginReset: (state) => {
    state.loading = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  googleLoginRequest: (state) => {
    state.loading = true;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  googleLoginSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  googleLoginFailure: (state, action) => {
    state.loading = false;
    state.data = [];
    state.msg = action.payload;
    state.error = null;
  },
});


export const userProfileReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  userProfileReset: (state) => {
    state.loading = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  userProfileRequest: (state) => {
    state.loading = true;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  userProfileSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  userProfileFailure: (state, action) => {
    state.loading = false;
    state.data = [];
    state.msg = action.payload;
    state.error = null;
  },
});


export const adminUserListReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  adminUserListReset: (state) => {
    state.loading = false;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  adminUserListRequest: (state) => {
    state.loading = true;
    state.data = [];
    state.msg = null;
    state.error = null;
  },
  adminUserListSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  adminUserListFailure: (state, action) => {
    state.loading = false;
    state.msg = action.payload;
    state.error = null;
  },
});
